<template>
  <div class="ecm__detail section__padding">
    <ModalAddCart ref="modalAddCart" />
    <DetailSkeleton v-if="activeSkeleton"/>
    <div
      class="ecm__detail-book"
      v-if="!activeSkeleton"
    >
      <div class="ecm__detail-book__cover">
        <img :src="book.cover" alt="">
      </div>
      <div class="ecm__detail-book__desc">
        <div class="ecm__detail-book__desc-header">
          <h1 class="ecm__detail-book__desc-header--title">
            {{ book.title }}
          </h1>
        </div>
        <div class="ecm__detail-book__desc-content">
          <div class="ecm__detail-book__desc-content__item">
            <p class="ecm__detail-book__desc-content__item-key">Title</p>
            <p class="ecm__detail-book__desc-content__item-value">
              {{ book.title }}
            </p>
          </div>
          <div class="ecm__detail-book__desc-content__item">
            <p class="ecm__detail-book__desc-content__item-key">Author</p>
            <p class="ecm__detail-book__desc-content__item-value author">{{ book.Author.full_name }}</p>
          </div>
          <div class="ecm__detail-book__desc-content__item">
            <p class="ecm__detail-book__desc-content__item-key">ISBN No</p>
            <p class="ecm__detail-book__desc-content__item-value">{{ book.isbn_number }}</p>
          </div>
          <div class="ecm__detail-book__desc-content__item">
            <p class="ecm__detail-book__desc-content__item-key">Publisher</p>
            <p class="ecm__detail-book__desc-content__item-value">{{ book.Publisher.name }}</p>
          </div>
          <div class="ecm__detail-book__desc-content__item">
            <p class="ecm__detail-book__desc-content__item-key">Date of publish</p>
            <p class="ecm__detail-book__desc-content__item-value"> {{ book.date_of_publish }} </p>
          </div>
          <div class="ecm__detail-book__desc-content__item">
            <p class="ecm__detail-book__desc-content__item-key">Number Of pages</p>
            <p class="ecm__detail-book__desc-content__item-value">{{ book.number_of_pages }}</p>
          </div>
          <div class="ecm__detail-book__desc-content__item">
            <p class="ecm__detail-book__desc-content__item-key">Category</p>
            <p class="ecm__detail-book__desc-content__item-value">{{ book.Category.name }}</p>
          </div>
        </div>
        <div class="ecm__detail-book__desc-price">
          <p class="ecm__detail-book__desc-price__item margin-right">Rp {{ formatPrice(book.price) }}</p>
          <div class="ecm__detail-book__desc-price__quantity margin-right">
            <div class="ecm__detail-book__desc-price__quantity-action">
              <button class="plus" @click="handleIncrementQuantity">+</button>
              <span class="count">{{ quantity }}</span>
              <button class="minus" @click="handleDecrementQuantity">-</button>
            </div>
          </div>
          <button class="ecm__detail-book__desc-price--btn-action btn-cart"
            @click="handleAddCart(book.id)"
          >
            <i class="fas fa-cart-plus"></i>
          </button>
          <button
            :class="[is_wishlist ? 'ecm__detail-book__desc-price--btn-action btn-wishlist is-active' : 'ecm__detail-book__desc-price--btn-action btn-wishlist']"
            @click="handleAddWishlist(book.id)"
          >
            <i class="fas fa-heart"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import formatDisplay from '@/mixins/formatDisplay.js'
import ModalAddCart from '@/components/modals/AddCart'
import DetailSkeleton from '@/components/skeleton/Detail'

export default {
  name: 'Detail',
  mixins: [formatDisplay],
  components: {
    ModalAddCart,
    DetailSkeleton
  },
  data () {
    return {
      book: null,
      quantity: 1,
      is_wishlist: false,
      activeSkeleton: true
    }
  },
  mounted () {
    this.$root.$on('fetchBook', (payload) => {
      this.handleFetchBook()
    })
    this.handleFetchBook()
  },
  methods: {
    ...mapActions({
      fetchOneBook: 'book/fetchOneBook',
      addCart: 'cart/addCart',
      addWishlist: 'wishlist/addWishlist',
      fetchWishlistCount: 'wishlist/fetchCount',
      fetchCartCount: 'cart/fetchCount'
    }),
    async handleFetchBook () {
      this.$data.activeSkeleton = true
      try {
        const data = await this.fetchOneBook({
          bookId: this.$route.params.book_id,
          userId: localStorage.getItem('userId')
        })
        if (data.status === 'success') {
          setTimeout(() => {
            this.$data.book = data.data
            if (this.$data.book && this.$data.book.Cart) {
              this.$data.quantity = this.$data.book.Cart.quantity
            } else {
              this.$data.quantity = 1
            }
            if (this.$data.book.is_wishlist) {
              this.$data.is_wishlist = this.$data.book.is_wishlist
            } else {
              this.$data.is_wishlist = false
            }
            this.$data.activeSkeleton = false
          }, 1000)
        }
      } catch (error) {
        console.warn(error.response, 'yuhuuu')
      }
    },
    handleIncrementQuantity () {
      if (this.$data.quantity < this.$data.book.stock) {
        this.$data.quantity++
      }
    },
    handleDecrementQuantity () {
      if (this.$data.quantity > 1) {
        this.$data.quantity--
      }
    },
    async handleAddCart (bookId) {
      if (!localStorage.getItem('access_token')) {
        this.$router.push('/login')
      } else {
        try {
          const resp = await this.addCart({
            bookId,
            quantity: this.$data.quantity
          })
          if (resp.msg === 'cart added') {
            this.fetchCartCount()
            this.$refs.modalAddCart.handleShowDialog()
          }
        } catch (error) {
          if (error?.response?.data?.msg === "can't exceed stock limit") {
            this.$message({
              showClose: false,
              message: "can't exceed stock limit",
              type: 'error',
            })
          } else if (error?.response?.data?.msg === "data not found") {
            this.$message({
              showClose: false,
              message: "This book is no longer available",
              type: 'error',
            })
          } else if (error?.response?.data?.msg === "can't exceed stock limit") {
            this.$message({
              showClose: false,
              message: "can't exceed stock limit",
              type: 'error',
            })
          }
        }
      }
    },
    async handleAddWishlist (bookId) {
      if (!localStorage.getItem('access_token')) {
        this.$router.push('/login')
      } else {
        try {
          const resp = await this.addWishlist({ bookId })
          if (resp.msg === 'wishlist deleted') {
            this.$data.is_wishlist = false
          } else {
            this.$data.is_wishlist = true
          }
          this.fetchWishlistCount()
        } catch (error) {
          if (error?.response?.data?.msg === 'data not found') {
            this.$message({
              showClose: false,
              message: "This book is no longer available",
              type: 'error',
            })
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ecm__detail {
  .ecm__detail-book {
    display: flex;
    .ecm__detail-book__cover {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 20%;
      overflow: hidden;
      border: 1px solid var(--color-blue-background);
      height: 320px;
      padding: 5px;
      img {
        width: 100%;
      }
    }
    .ecm__detail-book__desc {
      width: 100%;
      margin-left: 30px;
      .ecm__detail-book__desc-header {
        .ecm__detail-book__desc-header--title {
          color: var(--color-blue-background);
          font-weight: 500;
          font-size: 27px;
          width: 100%;
        }
      }
      .ecm__detail-book__desc-content {
        margin-top: 13px;
        .ecm__detail-book__desc-content__item {
          display: flex;
          margin-bottom: 3px;
          &:last-child {
            margin-bottom: 0;
          }
          font-weight: 400;
          .ecm__detail-book__desc-content__item-key {
            width: 170px;
          }
          .ecm__detail-book__desc-content__item-value {
            &.author {
              color: var(--color-blue-background);
            }
          }
        }
      }
      .ecm__detail-book__desc-price,
      .ecm__detail-book__desc-price__quantity,
      .ecm__detail-book__desc-price__quantity-action {
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
      .ecm__detail-book__desc-price {
        margin: 5px 0;
        .margin-right {
          margin-right: 20px;
        }
        .ecm__detail-book__desc-price__item {
          color: var(--color-pink);
          font-size: 23px;
          font-weight: 600;
        }
        .ecm__detail-book__desc-price__quantity {
          justify-content: space-between;
          color: var(--color-blue-background);
          height: 40px;
          cursor: default;
          .ecm__detail-book__desc-price__quantity-title {
            margin-right: 10px;
          }
          .ecm__detail-book__desc-price__quantity-action {
            justify-content: space-between;
            font-weight: 500;
            .plus, .minus {
              font-size: 14px;
              width: 21px;
              height: 21px;
              border-radius: 50%;
              color: white;
              font-weight: 600;
              cursor: pointer;
              border: none;
              outline: none;
              background: var(--color-blue-background);
            }
            .count {
              text-align: center;
              width: 70px;
            }
          }
        }
        .ecm__detail-book__desc-price--btn-action {
          border: none;
          outline: none;
          height: 30px;
          width: 30px;
          color: white;
          border-radius: 50%;
          transition: .3s ease-out;
          cursor: pointer;
          font-size: 12px;
          &.btn-cart {
            background: rgb(255, 123, 0);
            &:hover {
              background: rgb(255, 81, 0);
            }
          }
          &.btn-wishlist {
            background: rgba(255, 140, 136, 0.761);
            &.is-active {
              background: rgb(255, 8, 0);
            }
          }
          &:not(:last-child) {
            margin-right: 10px;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  .ecm__detail {
    .ecm__detail-book {
      .ecm__detail-book__cover {
        height: 360px;
        flex: .4;
      }
      .ecm__detail-book__desc {
        .ecm__detail-book__desc-title {
          font-size: 30px;
          height: 50px;
        }
        .ecm__detail-book__desc-content {
          .ecm__detail-book__desc-content__item {
            font-size: 16px;
            .ecm__detail-book__desc-content__item-key {
              width: 250px;
            }
            .ecm__detail-book__desc-content__item-value {
              width: 100%;
            }
          }
        }
        .ecm__detail-book__desc-price {
          font-size: 18px;
          margin: 3px 0;
        }
        .ecm__detail-book__desc-actions {
          .ecm__detail-book__desc-actions__quantity,
          .ecm__detail-book__desc-actions__chart,
          .ecm__detail-book__desc-actions__wishlist {
            padding: 8px 16px;
            font-size: 12px;
          }
          .ecm__detail-book__desc-actions__quantity {
            width: 150px;
            .plus, .minus {
              width: 10px !important;
            }
            .count {
              padding: 0 8px !important;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .ecm__detail {
    .ecm__detail-book {
      .ecm__detail-book__cover {
        height: 380px;
        flex: .7;
      }
      .ecm__detail-book__desc {
        .ecm__detail-book__desc-title {
          font-size: 20px;
          height: 60px;
        }
        .ecm__detail-book__desc-content {
          .ecm__detail-book__desc-content__item {
            font-size: 12.5px;
            .ecm__detail-book__desc-content__item-key {
              width: 120px;
            }
            .ecm__detail-book__desc-content__item-value {
              width: 100%;
            }
          }
        }
        .ecm__detail-book__desc-price {
          font-size: 15px;
          margin: 5px 0;
        }
        .ecm__detail-book__desc-actions {
          flex-wrap: wrap;
          .ecm__detail-book__desc-actions__quantity,
          .ecm__detail-book__desc-actions__chart,
          .ecm__detail-book__desc-actions__wishlist {
            padding: 8px 16px;
            font-size: 10px;
            margin-bottom: 5px;
            margin-right: 5px;
          }
          .ecm__detail-book__desc-actions__quantity {
            width: 130px;
            .ecm__detail-book__desc-actions__quantity-title {
              margin-right: 10px;
            }
            .plus, .minus {
              width: 10px !important;
            }
            .count {
              padding: 0 8px !important;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 481px) {
  .ecm__detail {
    .ecm__detail-book {
      display: block;
      .ecm__detail-book__cover {
        height: 270px;
      }
      .ecm__detail-book__desc {
        margin-top: 15px;
        .ecm__detail-book__desc-title {
          font-size: 13px;
          height: auto;
        }
        .ecm__detail-book__desc-content {
          .ecm__detail-book__desc-content__item {
            font-size: 12px;
            .ecm__detail-book__desc-content__item-key {
              width: 180px;
            }
            .ecm__detail-book__desc-content__item-value {
              width: 100%;
            }
          }
        }
        .ecm__detail-book__desc-price {
          font-size: 13px;
          margin: 2px 0 6px;
        }
        .ecm__detail-book__desc-actions {
          flex-wrap: nowrap;
          .ecm__detail-book__desc-actions__quantity,
          .ecm__detail-book__desc-actions__chart,
          .ecm__detail-book__desc-actions__wishlist {
            font-size: 11px;
            padding: 7px 10px;
            margin-bottom: 0;
            margin-right: 5px;
            justify-content: center;
          }
          .ecm__detail-book__desc-actions__quantity {
            width: 130px;
            .ecm__detail-book__desc-actions__quantity-title {
              margin-right: 10px;
            }
            .plus, .minus {
              width: 10px !important;
            }
            .count {
              padding: 0 8px !important;
            }
          }
          .ecm__detail-book__desc-actions__wishlist,
          .ecm__detail-book__desc-actions__chart {
            color: white;
            cursor: pointer;
            transition: .1s background;
            // min-width: 80px;
            i {
              margin-right: 0;
            }
            .desc {
              display: none;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 320px) {
  .ecm__detail {
    .ecm__detail-book {
      display: block;
      .ecm__detail-book__cover {
        height: 200px;
      }
      .ecm__detail-book__desc {
        margin-top: 15px;
        .ecm__detail-book__desc-title {
          font-size: 13px;
          height: auto;
        }
        .ecm__detail-book__desc-content {
          .ecm__detail-book__desc-content__item {
            font-size: 11px;
          }
        }
        .ecm__detail-book__desc-price {
          font-size: 12px;
          margin: 3px 0 7px;
        }
        .ecm__detail-book__desc-actions {
          .ecm__detail-book__desc-actions__quantity,
          .ecm__detail-book__desc-actions__chart,
          .ecm__detail-book__desc-actions__wishlist {
            font-size: 11px;
            padding: 7px 10px;
            margin-bottom: 0;
            margin-right: 5px;
            justify-content: center;
          }
          .ecm__detail-book__desc-actions__quantity {
            justify-content: space-between;
            width: 130px;
            .ecm__detail-book__desc-actions__quantity-title {
              margin-right: 10px;
            }
          }
        }
      }
    }
  }
}
</style>
